import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const eventSummaryGridColumns1 = () => [
    {
        field: 'attribute',
        headerName: 'Event Attribute',
        width: 120,
    },
    {
        field: 'events',
        headerName: 'Events',
        filter: 'agTextColumnFilter',
        width: 95,
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'perc_total_events',
        headerName: '% Total events',
        filter: 'agNumberColumnFilter',
        width: 98,
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'min_duration',
        headerName: 'Min Duration',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'max_duration',
        headerName: 'Max Duration',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'avg_duration_days',
        headerName: 'Avg Duration (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'avg_duration_hrs',
        headerName: 'Avg Duration (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
    {
        field: 'std_deviation_days',
        headerName: 'Std Deviation (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_hrs',
        headerName: 'Std Deviation (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
];
